import React from 'react';
import { createFileRoute, Outlet, useSearch } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { EntityProjectionName } from '@utils/entityProjectionNames';
import { CodeOwner } from '@utils/router.utils';
import { useGetAllRiskScoringConfig } from '@views/RiskScore/hooks';
import { RiskScoreProvider } from '@views/RiskScore/RiskScoreContext';

const RiskScoreLayout = () => {
  const { data } = useGetAllRiskScoringConfig();
  const { scoreType } = useSearch({ strict: false }) as { scoreType: EntityProjectionName };

  if (!data) {
    return null;
  }

  return (
    <RiskScoreProvider data={data} riskScoreProjectionName={scoreType}>
      <Outlet />
    </RiskScoreProvider>
  );
};

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/risk-score')({
  beforeLoad: () => getTitleContextSlice('Risk Score'),
  staticData: {
    owner: CodeOwner.Uvm,
  },
  component: RiskScoreLayout,
});
